import AccountIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import {
  Button,
  Divider,
  Box,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem
} from '@mui/material';
import { useUserState } from 'context/User';
import React from 'react';
import { useAuth } from 'react-oidc-context';
import { Link } from 'react-router-dom';
import Settings from '@mui/icons-material/Settings';
import { UserStateContextType } from 'components/constants/Constants';
import {
  useCanSeeUserAccess,
  useCanSeeProductEditor
} from 'hooks/useUserState_utils';
import { UXB_ROUTE_NAMES } from '../UXBRouteNames';

export const UserMenuButton = () => {
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const userOpen = Boolean(anchorElUser);

  const { signinRedirect, signoutRedirect } = useAuth();
  const userState = useUserState();

  const canSeeProductEditor = useCanSeeProductEditor();
  const canSeeUserAccess = useCanSeeUserAccess();
  return userState.type === UserStateContextType.AUTHENTICATED ? (
    <>
      <IconButton color="primary" onClick={handleOpenUserMenu}>
        <AccountIcon />
      </IconButton>
      {anchorElUser && (
        <Menu
          anchorEl={anchorElUser}
          open={userOpen}
          onClose={handleCloseUserMenu}
          MenuListProps={{
            dense: true
          }}
        >
          <MenuItem
            disabled
            sx={{
              '&.Mui-disabled': {
                opacity: 1
              }
            }}
          >
            <ListItemText
              primary={`${userState.user?.firstName} ${userState.user?.lastName}`}
              secondary={userState.user?.username}
            />
          </MenuItem>

          <Divider />
          <MenuItem
            component={Link}
            to={UXB_ROUTE_NAMES.userProfile}
            onClick={handleCloseUserMenu}
          >
            <ListItemIcon>
              <AccountIcon />
            </ListItemIcon>
            <ListItemText>My Account</ListItemText>
          </MenuItem>
          {(canSeeProductEditor || canSeeUserAccess) && (
            <MenuItem
              component={Link}
              to="/admin"
              onClick={handleCloseUserMenu}
            >
              <ListItemIcon>
                <Settings />
              </ListItemIcon>
              <ListItemText>Admin</ListItemText>
            </MenuItem>
          )}

          <Divider />
          <MenuItem
            onClick={() => {
              signoutRedirect({
                post_logout_redirect_uri:
                  window.location.origin + window.location.pathname
              });
              handleCloseUserMenu();
            }}
          >
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText>Sign out</ListItemText>
          </MenuItem>
        </Menu>
      )}
    </>
  ) : (
    <Box
      sx={{
        gap: 1,
        display: 'flex'
      }}
    >
      <Button
        variant="outlined"
        onClick={() =>
          signinRedirect({
            redirect_uri: window.location.origin + window.location.pathname
          })
        }
      >
        Log In
      </Button>
      <Button component={Link} to="/register" variant="contained">
        Register
      </Button>
    </Box>
  );
};
